import { useState, useEffect } from 'react'
import { api } from '@/api/client'
import type { ApiStatus } from '@/api/client'

export function useApiStatus(): ApiStatus {
  const [status, setStatus] = useState<ApiStatus>(api.status)

  useEffect(() => {
    const listener = (s: ApiStatus) => setStatus(s)
    api.onStatusChange(listener)
    return () => api.offStatusChange(listener)
  }, [])

  return status
}
